import { IconButton } from "@mui/material";
import { SignOutIcon } from "@phosphor-icons/react";
import * as Sentry from "@sentry/react";
import { useRouter } from "@tanstack/react-router";
import { useState } from "react";

import { accessTokenStorage, refreshTokenStorage } from "@/utils/tokens";

export const LogOutButton = () => {
  const [isNavigating, setIsNavigating] = useState(false);
  const { invalidate } = useRouter();

  return (
    <IconButton
      color="inherit"
      size="small"
      aria-label="log out"
      onClick={async () => {
        setIsNavigating(true);
        try {
          accessTokenStorage.remove();
          refreshTokenStorage.remove();

          await invalidate();
        } catch (error) {
          Sentry.captureException(error);
        } finally {
          setIsNavigating(false);
        }
      }}
      loading={isNavigating}
    >
      <SignOutIcon weight="bold" />
    </IconButton>
  );
};
